import { isBoolean } from 'lodash';
import { formatAddress } from '../address/utils.js';

const updateTokens = (dispatch, accessToken, refreshToken) => {
    dispatch({ type: 'SET_AUTH_TOKENS', access_token: accessToken, refresh_token: refreshToken });
};

const updateState = (dispatch, payload) => {
    if (!payloadIsValid(payload)) {
        return;
    }

    dispatch({
        type: 'SET_PAGE_VALUE',
        identifier: 'hasBeenPrefilled',
        value: true
    });

    updatePrefill(dispatch, payload);

    // transaction and control state
    dispatch({ type: 'SET_JOURNEY_PAYLOAD', payload });

    // lookup data for houses built in 2011+
    dispatch({
        type: 'GET_YEAR_BUILT_VALUES',
        stateKey: verticalQuote
    });

    const form = payload.form;

    // prefill cover details
    const coverDetails = form?.coverDetails;
    dispatchSetValue(dispatch, 'coverDetails.coverType', coverDetails?.coverType);
    dispatchSetValue(dispatch, 'coverDetails.totalRebuildCost', coverDetails?.totalRebuildCost);
    dispatchSetValue(dispatch, 'coverDetails.totalContentReplacementCost', coverDetails?.totalContentReplacementCost);
    dispatchSetValue(dispatch, 'coverDetails.isAbovePolicyLimits', convertBool(coverDetails?.isAbovePolicyLimits));
    dispatchSetValue(dispatch, 'coverDetails.commencementDate', coverDetails?.commencementDate);

    // prefill data
    const data = form?.data;
    dispatchSetValue(dispatch, 'data.hasBusinessActivity', convertBool(data?.hasBusinessActivity));
    dispatchSetValue(dispatch, 'data.hasSecurityAlarm', convertBool(data?.hasSecurityAlarm));
    dispatchSetValue(dispatch, 'data.hasPortableItems', convertBool(data?.hasPortableItems));

    // prefill cover details - portable items
    const portableItems = coverDetails?.portableItems;
    // specifyPortableItems is not returned from journey service.
    // Determine if the value is Y or N.
    if (portableItems) {
        dispatchSetValue(dispatch, 'coverDetails.portableItems.specifyPortableItems', 'N');
        let hasSpecifyPortableItems = false;
        for (let key in portableItems) {
            if (key !== 'totalUnspecifiedPortableItems') {
            // If there is a value then specifyPortableItems = Y
                if (!!portableItems[key]) {
                    hasSpecifyPortableItems = true;
                }
            }
        }
        if (hasSpecifyPortableItems) {
            dispatchSetValue(dispatch, 'coverDetails.portableItems.specifyPortableItems', 'Y');
        }
    }

    // Portable Items
    dispatchSetValue(dispatch, 'coverDetails.portableItems.photographicEquipmentCover', portableItems?.photographicEquipmentCover);
    dispatchSetValue(dispatch, 'coverDetails.portableItems.sportingEquipmentCover', portableItems?.sportingEquipmentCover);
    dispatchSetValue(dispatch, 'coverDetails.portableItems.jewelryWatchesCover', portableItems?.jewelryWatchesCover);
    dispatchSetValue(dispatch, 'coverDetails.portableItems.clothingCover', portableItems?.clothingCover);
    dispatchSetValue(dispatch, 'coverDetails.portableItems.musicalInstrumentsCover', portableItems?.musicalInstrumentsCover);
    dispatchSetValue(dispatch, 'coverDetails.portableItems.bicyclesCover', portableItems?.bicyclesCover);
    dispatchSetValue(dispatch, 'coverDetails.portableItems.totalUnspecifiedPortableItems', portableItems?.totalUnspecifiedPortableItems);

    // prefill address
    dispatchFormAddressDetails(dispatch, form?.property?.address);

    // prefill policy holder details
    const policyHolder = form?.policyHolder;
    dispatchSetValue(dispatch, 'policyHolder.firstName', policyHolder?.firstName);
    dispatchSetValue(dispatch, 'policyHolder.lastName', policyHolder?.lastName);
    dispatchSetValue(dispatch, 'policyHolder.dob', policyHolder?.dob);

    // prefill callMeBack details
    dispatch({
        type: 'SET_FORM_VALUE',
        value: policyHolder?.firstName,
        identifier: 'name',
        stateKey: 'vertical.callMeBack'
    });

    if (form?.contactDetails?.mobile) {
        dispatch({
            type: 'SET_FORM_VALUE',
            value: form?.contactDetails?.mobile,
            identifier: 'mobile',
            stateKey: 'vertical.callMeBack'
        });
    }

    if (form?.contactDetails?.phone) {
        dispatch({
            type: 'SET_FORM_VALUE',
            value: form?.contactDetails?.phone,
            identifier: 'phone',
            stateKey: 'vertical.callMeBack'
        });
    }

    // prefill contact details
    const contactDetails = form?.contactDetails;
    dispatchSetValue(dispatch, 'contactDetails.email', contactDetails?.email);
    dispatchSetValue(dispatch, 'contactDetails.mobile', contactDetails?.mobile);
    dispatchSetValue(dispatch, 'contactDetails.phone', contactDetails?.phone);
    dispatchSetValue(dispatch, 'contactDetails.optinPrivacy', convertBool(contactDetails?.optinPrivacy));
    dispatchSetValue(dispatch, 'leadCapture.health', convertBool(form?.leadCapture?.health));

    // prefill previous cover
    const previousCover = form?.previousCover;
    dispatchSetValue(dispatch, 'previousCover.hasPreviousClaims', convertBool(previousCover?.hasPreviousClaims));

    // prefill occupancy
    const occupancy = form?.occupancy;
    dispatchSetValue(dispatch, 'occupancy.occupancyType', occupancy?.occupancyType);
    dispatchSetValue(dispatch, 'occupancy.hasMortgage', convertBool(occupancy?.hasMortgage));
    dispatchSetValue(dispatch, 'occupancy.isPrincipalResidence', convertBool(occupancy?.isPrincipalResidence));
    dispatchSetValue(dispatch, 'occupancy.whenMovedIn.year', occupancy?.whenMovedIn?.year);
    dispatchSetValue(dispatch, 'occupancy.whenMovedIn.month', occupancy?.whenMovedIn?.month);
    dispatchSetValue(dispatch, 'occupancy.isOldestResidentRetired', convertBool(occupancy?.isOldestResidentRetired));
    dispatchSetValue(dispatch, 'occupancy.howOccupied', occupancy?.howOccupied);

    // Landlord
    const landlordDetails = form?.landlordDetails;
    dispatchSetValue(dispatch, 'landlordDetails.managedBy', landlordDetails?.managedBy);
    dispatchSetValue(dispatch, 'landlordDetails.hasValidRentalLease', convertBool(landlordDetails?.hasValidRentalLease));
    dispatchSetValue(dispatch, 'landlordDetails.hasPendingRentalLease', convertBool(landlordDetails?.hasPendingRentalLease));
    dispatchSetValue(dispatch, 'landlordDetails.weeklyRentalValue', landlordDetails?.weeklyRentalValue);
    dispatchSetValue(dispatch, 'landlordDetails.numberOfTenants', landlordDetails?.numberOfTenants);

    // prefill property
    const property = form?.property;
    dispatchSetValue(dispatch, 'property.propertyType', property?.propertyType);
    dispatchSetValue(dispatch, 'property.wallMaterial', property?.wallMaterial);
    dispatchSetValue(dispatch, 'property.roofMaterial', property?.roofMaterial);
    dispatchSetValue(dispatch, 'property.yearBuilt', property?.yearBuilt);
    dispatchSetValue(dispatch, 'property.hasBodyCorporate', convertBool(property?.hasBodyCorporate));
    dispatchSetValue(dispatch, 'property.heritageListed', convertBool(property?.heritageListed));
    dispatchSetValue(dispatch, 'property.heritageOverlay', convertBool(property?.heritageOverlay));

    // property - security features
    const securityFeatures = property?.securityFeatures;
    dispatchSetValue(dispatch, 'property.securityFeatures.hasActiveBackToBaseMonitoring', convertBool(securityFeatures?.hasActiveBackToBaseMonitoring));
    dispatchSetValue(dispatch, 'property.securityFeatures.hasExternalStrobe', convertBool(securityFeatures?.hasExternalStrobe));
    dispatchSetValue(dispatch, 'property.securityFeatures.hasExternalSiren', convertBool(securityFeatures?.hasExternalSiren));
    dispatchSetValue(dispatch, 'property.securityFeatures.hasInternalSiren', convertBool(securityFeatures?.hasInternalSiren));

    // business activity
    const businessActivity = form?.businessActivity;
    dispatchSetValue(dispatch, 'businessActivity.isDayCareRegistered', convertBool(businessActivity?.isDayCareRegistered));
    dispatchSetValue(dispatch, 'businessActivity.numberOfChildren', businessActivity?.numberOfChildren);
    dispatchSetValue(dispatch, 'businessActivity.numberOfOtherEmployees', businessActivity?.numberOfOtherEmployees);
    dispatchSetValue(dispatch, 'businessActivity.numberOfBusinessRooms', businessActivity?.numberOfBusinessRooms);
    dispatchSetValue(dispatch, 'businessActivity.businessType', businessActivity?.businessType);
    // hasEmployees is not returned from journey service but required for UI
    if (form?.businessActivity?.numberOfOtherEmployees === '0') {
        dispatchSetValue(dispatch, 'businessActivity.hasEmployees', convertBool(false));
    } else if (form?.businessActivity?.numberOfOtherEmployees !== undefined) {
        dispatchSetValue(dispatch, 'businessActivity.hasEmployees', convertBool(true));
    }

    // excess details
    const excessDetails = form?.excessDetails;
    dispatchSetValue(dispatch, 'excessDetails.contentsExcess', excessDetails?.contentsExcess);
    dispatchSetValue(dispatch, 'excessDetails.homeExcess', excessDetails?.homeExcess);
    dispatch({
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: 'filters.contentsExcess',
        value: excessDetails?.contentsExcess.toString()
    });
    dispatch({
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: 'filters.homeExcess',
        value: excessDetails?.homeExcess.toString()
    });

    if (form?.excessDetails?.homeExcess) {
        dispatchSetValue(dispatch, 'helpers.prefill.previousHomeExcess', excessDetails?.homeExcess.toString());
    }

    if (form?.excessDetails?.contentsExcess) {
        dispatchSetValue(dispatch, 'helpers.prefill.previousContentsExcess', excessDetails?.contentsExcess.toString());
    }

    // quote results
    if (payload?.quote?.payload?.results) {
        // results payload
        dispatch({
            type: 'SET_RESULTS_PAYLOAD_HNC',
            payload
        });

        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'hasSeenResults',
            value: true
        });
    }
};

const dispatchFormAddressDetails = (dispatch, address) => {
    if (address === undefined) {
        return;
    }
    const addressLabel = formatAddress(address);

    dispatchSetValue(dispatch, 'helpers.propertyAddressLabel', addressLabel);
    dispatch({
        type: 'SET_VALUES',
        stateKey: verticalQuote,
        values: {
            property: {
                address: {
                    suburb: address?.suburb,
                    gnafId: address?.gnafId,
                    streetNumber: address?.streetNumber,
                    unitNumber: address?.unitNumber,
                    postcode: address?.postcode,
                    streetName: address?.streetName,
                    state: address?.state,
                    unitType: address?.unitType,
                    buildingName: address?.buildingName
                }
            }
        }
    });
};

const updatePrefill = (dispatch, payload) => {
    // if prefill object exists, remove any access tokens, before dispatching to state
    let prefill = {};
    if (payload?.prefill) {
        prefill = payload.prefill;
    } else {
        prefill.attempt = 0;
        prefill.access_token = null;
        prefill.refresh_token = null;
    }
    dispatch({
        type: 'SET_VALUE',
        value: prefill,
        stateKey: 'vertical.quote',
        identifier: 'helpers.prefill'
    });
};

// Dispatch a value to the state, unless it's undefined
// Null might be a valid value so we leave it as is
const dispatchSetValue = (dispatch, identifier, value) => {
    if (value === undefined) {
        return;
    }
    dispatch({
        type: 'SET_VALUE',
        stateKey: verticalQuote,
        identifier,
        value
    });
};

// Basic payload check to ensure it is not empty
const payloadIsValid = (payload) => {
    return payload && Object.keys(payload).length > 0 && payload.form;
};

// Convert boolean values to 'Y' or 'N'
const convertBool = (val) => {
    if (isBoolean(val)) {
        return val === true ? 'Y' : 'N';
    }
    return val;
};

const verticalQuote = 'vertical.quote';

export { updateState, updateTokens };
